import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import "./style.css";

import forest_fire_new_logo from "../../images/forest_fire_new_logo.jpeg";
import fireLogo from "../../images/firelogo.jpeg";

export default function TopAppBar() {
  const history = useHistory();
  const user = JSON.parse(localStorage["user"]);
  const organization = user.organization;
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const logo =
    user?.username === "punjabadmin" ? forest_fire_new_logo : fireLogo;
  const logoSize = user?.username === "punjabadmin" ? "220" : "150";

  const handleDevicesClick = () => {
    history.push("/devices");
  };

  const handle_admin_click = () => {
    window.location = "https://api.forestwatch.org.pk/admin";
  };

  const handleLogout = () => {
    window.location = "/logout";
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  // Helper function to check if a path is active
  const isActive = (path) => {
    return history.location.pathname === path;
  };

  return (
    <header
      style={{
        background: "white",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
      }}
      className="mdc-top-app-bar mdc-top-app-bar--fixed js-top-app-bar"
    >
      <div className="mdc-top-app-bar__row contain-full-bleed links--muted ">
        <section className="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
          <Link to="/" className="mdc-top-app-bar__title">
            <img width={logoSize} src={logo} alt="Project Logo" />
          </Link>
        </section>

        <section
          className="mdc-top-app-bar__section app-shop mdc-top-app-bar__section--align-end mr4"
          role="toolbar"
          style={{ position: "relative" }}
        >
          {/* Home Button */}
          <Link to="/" className="show-lg link-mute">
            <button
              className="mdc-button mdc-theme--primary mdc-top-app-bar__action-item"
              style={{
                backgroundColor: isActive("/") ? "#ff4444" : "transparent",
                color: isActive("/") ? "white" : "#ff4444",
                borderRadius: "25px",
                padding: "8px 20px",
                margin: "0 5px",
                transition: "all 0.3s ease",
              }}
            >
              <span className="mdc-button__ripple" />
              <span className="mdc-button__label">Home</span>
            </button>
          </Link>

          {/* Dashboard Button */}
          <Link to="/dashboard" className="show-lg link-mute">
            <button
              className="mdc-button mdc-theme--primary mdc-top-app-bar__action-item"
              style={{
                backgroundColor: isActive("/dashboard")
                  ? "#ff4444"
                  : "transparent",
                color: isActive("/dashboard") ? "white" : "#ff4444",
                borderRadius: "25px",
                padding: "8px 20px",
                margin: "0 5px",
                transition: "all 0.3s ease",
              }}
            >
              <span className="mdc-button__ripple" />
              <span className="mdc-button__label">Dashboard</span>
            </button>
          </Link>

          {/* Devices Button */}
          <button
            className="mdc-button mdc-theme--primary mdc-top-app-bar__action-item"
            onClick={handleDevicesClick}
            style={{
              backgroundColor: isActive("/devices") ? "#ff4444" : "transparent",
              color: isActive("/devices") ? "white" : "#ff4444",
              borderRadius: "25px",
              padding: "8px 20px",
              margin: "0 5px",
              transition: "all 0.3s ease",
            }}
          >
            <span className="mdc-button__ripple" />
            Devices
          </button>

          {/* Profile Button */}
          <button
            className="mdc-button mdc-theme--primary mdc-top-app-bar__action-item profile-button"
            onClick={toggleDropdown}
            style={{
              marginLeft: "10px",
              backgroundColor: dropdownOpen ? "#ff4444" : "transparent",
              color: dropdownOpen ? "white" : "#ff4444",
              borderRadius: "50%",
              padding: "8px",
              transition: "all 0.3s ease",
            }}
          >
            <AccountCircleIcon style={{ fontSize: 30 }} />
          </button>

          {/* Profile Dropdown */}
          {dropdownOpen && (
            <div
              style={{
                position: "absolute",
                top: "100%",
                right: 0,
                backgroundColor: "white",
                borderRadius: "12px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
                minWidth: "200px",
                zIndex: 1000,
                marginTop: "10px",
                padding: "10px 0",
              }}
            >
              <div
                style={{ padding: "15px 20px", borderBottom: "1px solid #eee" }}
              >
                <span
                  style={{
                    color: "#333",
                    fontWeight: "700",
                    display: "block",
                    marginBottom: "5px",
                  }}
                >
                  {user.username}
                </span>
                <span style={{ color: "#666", fontSize: "12px" }}>
                  {organization === "CVGL" ? "Administrator" : "User"}
                </span>
              </div>

              {organization === "CVGL" && (
                <button
                  onClick={handle_admin_click}
                  style={{
                    width: "100%",
                    padding: "12px 20px",
                    border: "none",
                    background: "white",
                    color: "#333",
                    cursor: "pointer",
                    textAlign: "left",
                    fontSize: "14px",
                    transition: "all 0.2s ease",
                    borderBottom: "1px solid #eee",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor = "#f5f5f5")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.backgroundColor = "white")
                  }
                >
                  Admin Panel
                </button>
              )}

              <button
                onClick={handleLogout}
                style={{
                  width: "100%",
                  padding: "12px 20px",
                  border: "none",
                  background: "white",
                  color: "#ff4444",
                  cursor: "pointer",
                  textAlign: "left",
                  fontSize: "14px",
                  fontWeight: "600",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#fff5f5")
                }
                onMouseLeave={(e) => (e.target.style.backgroundColor = "white")}
              >
                Log out
              </button>
            </div>
          )}

          <button
            className="menu-mobile material-icons mdc-theme--primary mdc-top-app-bar__navigation-icon mdc-icon-button dn-l js-trigger-mdc-drawer"
            aria-label="Open navigation menu"
          >
            menu
          </button>
        </section>
      </div>
    </header>
  );
}
